import React, { Component } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import ReCAPTCHA from "react-google-recaptcha";
import "./Abha.css";
export default class Mobilenumberotp extends Component {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      mobile: sessionStorage.getItem("mobile"),
      otp: ["", "", "", "", "", ""],
      showOtp: false,
      resendTimer: 60, // 10 minutes
      resendEnabled: false,
      resendIntervalId: null,
      isResendDisabled: false,
      captchaToken: null,
    };
  }
  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };
  handleCaptchaChange = (value) => {
    this.setState({
      captchaToken: value,
    });
  };
  resetCaptcha = () => {
    this.setState({ captchaToken: "" });
    if (this.recaptchaRef && this.recaptchaRef.current) {
      this.recaptchaRef.current.reset();
    }
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  componentDidMount() {
    if (!sessionStorage.getItem("resendOtpmobileCount")) {
      sessionStorage.setItem("resendOtpmobileCount", "0");
    }
    this.startResendCountdown();
  }

  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpmobileCount:
        parseInt(sessionStorage.getItem("resendOtpmobileCount")) || 0,
      resendTimer: 60,
    }); // Start with 5 minutes
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 }; // Re-enable button after timer ends
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
  handleOtpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      // allow only single digit or empty
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.otp];
          newOtp[index] = val;
          return { otp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput${index + 1}`].focus();
          }
        }
      );
    }
  };
  handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !this.state.otp[index] && index > 0) {
      this[`otpInput${index - 1}`].focus();
    }
  };
  handleSubmitBack = () => {
    window.location.href = "/mobileauthentication";
  };

  handleOtpVerification = (e) => {
    e.preventDefault();
    const { captchaToken } = this.state;
    const otp = this.state.otp.join("");

    if (!captchaToken) {
      alert("Please verify that you are not a robot!");
      return;
    }
    const formData = new FormData();
    formData.append("captchaToken", captchaToken);
    formData.append("otp", otp);
    formData.append("mobile", sessionStorage.getItem("mobile"));
    formData.append("index", sessionStorage.getItem("requestId"));
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitMobileSearchOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("resendOtpmobileCount", "");
          this.setState({
            resendOtpmobileCount: "",
          });
          window.location.href = "/mobileabhaprofile";
        }
      });
  };
  toggleOtpVisibility = () => {
    this.setState((prevState) => ({ showOtp: !prevState.showOtp }));
  };
  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };

  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount =
      parseInt(sessionStorage.getItem("resendOtpmobileCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Maximum resend attempts reached.", "warning");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/resendMobileSearchOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("resendOtpmobileCount", resendCount + 1);
          clearInterval(this.state.resendIntervalId);
        }
      });
  };
  render() {
    const { showOtp, resendEnabled, resendTimer, otp, mobile } = this.state;
    return (
      <div>
        <div className="row mb-2 withMobileNumberAbhaGen" id="flowStyle">
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 flowTab active-page">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">ABHA Authentication</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Communication Details</p>
            </div>
          </div>
          <div className="col-md-3 flowTab Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA Address Creation</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-md-center text-center">
          <div className="col-md-6 mt-3">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form>
                <Form.Group>
                  <div
                    className="d-flex gap-2 mb-2"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Form.Label>
                      <b>Confirm OTP</b>
                    </Form.Label>

                    <i style={{ color: "blue" }}>
                      OTP has been sent to this Mobile number&nbsp;
                      {mobile ? "******" + mobile.slice(-4) : ""}
                    </i>
                  </div>
                  <div
                    className="d-flex gap-2"
                    style={{ justifyContent: "center" }}
                  >
                    {otp.map((digit, index) => (
                      <Form.Control
                        key={index}
                        type={showOtp ? "text" : "password"}
                        maxLength="1"
                        value={digit}
                        onChange={(e) => this.handleOtpChange(e, index)}
                        onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                        ref={(input) => (this[`otpInput${index}`] = input)}
                        style={{
                          textAlign: "center",
                        }}
                      />
                    ))}
                    <Button
                      variant="outline-secondary"
                      className={`rounded-0 bi ${
                        showOtp ? "bi-eye-slash" : "bi-eye"
                      }`}
                      onClick={() => this.setState({ showOtp: !showOtp })}
                    />
                  </div>
                </Form.Group>
              </Form>
              <div as={Row}>
                <div className="col">
                  {parseInt(sessionStorage.getItem("resendOtpmobileCount")) >=
                  2 ? (
                    <div style={{ color: "red", fontWeight: "bold" }}>
                      You’ve reached the maximum resend attempts.
                    </div>
                  ) : (
                    <Button
                      className="rounded-0 m-3"
                      variant="warning"
                      onClick={this.ResendOTP}
                      disabled={!resendEnabled}
                    >
                      Resend OTP{" "}
                      {!resendEnabled && `in ${this.formatTime(resendTimer)}`}
                    </Button>
                  )}
                </div>
                <div className="d-flex">
                  <ReCAPTCHA
                    className="mt-4"
                    ref={this.recaptchaRef}
                    sitekey={configData.captchaKey}
                    onChange={this.handleCaptchaChange}
                  />{" "}
                  <Button
                    variant="secondary"
                    className="bi bi-arrow-clockwise mt-5"
                    style={{
                      height: "50px",
                      backgroundColor: "#f9f9f9",
                      color: "red",
                    }}
                    onClick={() => this.recaptchaRef.current.reset()}
                  />
                </div>
                <div className="col"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2 d-flex">
          <div className="col text-start">
            <Button
              className="rounded-0 m-1 "
              variant="warning"
              onClick={this.handleSubmitBack}
            >
              Back
            </Button>
          </div>
          <div className="col text-end">
            <Button
              className="rounded-0 m-1"
              onClick={this.handleOtpVerification}
            >
              Verify OTP
            </Button>
          </div>
        </div>
        <div className="row" style={{ height: "300px" }}></div>
      </div>
    );
  }
}
